import React from 'react';
import {View} from 'react-native';

import ListItem from '/component/base/ListItem';
import {LoadingBox} from '/component/base/LoadingBox';
import Text from '/component/base/Text';
import Gutter from '/component/layout/Gutter';
import {withTranslation} from '/provider/TranslationProvider';

import {styles} from './Loading.style';

interface LoadingProps {
  tt: (key: string, defaultText?: string) => string;
  renderTitle: () => string;
}

const Loading: React.FC<LoadingProps> = ({tt, renderTitle = () => ''}) => {
  return (
    <View style={styles.base}>
      <View style={styles.header}>
        <Gutter>
          <Text variant="heading">{renderTitle()}</Text>
        </Gutter>
      </View>
      <Gutter>
        <ListItem
          style={{base: styles.listItem}}
          readonly
          label={<Text>{tt('activationDate', 'Activation Date')}</Text>}
          suffix={<LoadingBox style={styles.loadingBoxActivationDate} />}
        />
      </Gutter>
      <Gutter>
        <ListItem
          style={{base: styles.listItem}}
          readonly
          label={<Text>{tt('businessCoach', 'Business Coach')}</Text>}
          suffix={<LoadingBox style={styles.loadingBoxBusinessCoach} />}
        />
      </Gutter>
      <Gutter>
        <ListItem
          style={{base: styles.listItem}}
          readonly
          label={
            <Text>{tt('highestRankAchieved', 'Highest Rank Achieved')}</Text>
          }
          suffix={<LoadingBox style={styles.loadingBoxHighestAchievedRank} />}
        />
      </Gutter>
      <Gutter>
        <ListItem
          style={{base: styles.listItem}}
          readonly
          label={<Text>{tt('orderingEntities', 'Ordering Entities')}</Text>}
          suffix={<LoadingBox style={styles.loadingBoxOrderingEntities} />}
        />
      </Gutter>
      <Gutter>
        <ListItem
          style={{base: styles.listItem}}
          readonly
          label={<Text>{tt('qualifyingPoints', 'Qualifying Points')}</Text>}
          suffix={<LoadingBox style={styles.loadingBoxQualifyingPoints} />}
        />
      </Gutter>
    </View>
  );
};

export default withTranslation('reportCardContent.allCoaches')(Loading);
export const UnwrappedLoading = Loading;
